module.exports = __webpack_public_path__ + "img/034-frankenstein.b10b031b.png";